<template>
  <img
    :data-src="src"
    :data-srcset="srcset"
    :style="style"
    class="AppImage"
    :alt="alt"
  >
</template>

<script>
import lozad from 'lozad';

export default {
  name: 'LazyImage',
  props: {
    backgroundColor: {
      type: String,
      default: '#efefef',
    },
    height: {
      type: Number,
      default: null,
    },
    src: {
      type: String,
      default: null,
    },
    srcset: {
      type: String,
      default: null,
    },
    width: {
      type: Number,
      default: null,
    },
    alt: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    aspectRatio() {
      // Calculate the aspect ratio of the image
      if (!this.width || !this.height){
        return null;
      }

      return (this.height / this.width) * 100;
    },
    style() {
      const style = {backgroundColor: this.backgroundColor};

      if (this.width) style.width = `${this.width}px`;

      const applyAspectRatio = this.loading && this.aspectRatio;
      if (applyAspectRatio) {
        style.height = 0;
        style.paddingTop = `${this.aspectRatio}%`;
      }

      return style;
    },
  },
  mounted() {
    const setLoadingState = () => {
      this.loading = false;
    };
    this.$el.addEventListener('load', setLoadingState);

    this.$once('hook:destroyed', () => {
      this.$el.removeEventListener('load', setLoadingState);
    });

    const observer = lozad(this.$el);
    observer.observe();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/partials/LazyImage.vue